import { render } from "./DatadogMonitor.vue?vue&type=template&id=685466e0&scoped=true"
import script from "./DatadogMonitor.vue?vue&type=script&lang=js"
export * from "./DatadogMonitor.vue?vue&type=script&lang=js"

import "./DatadogMonitor.vue?vue&type=style&index=0&id=685466e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685466e0"]])

export default __exports__